import * as React from 'react'
import { Container } from './Container'
import geometricM from './images/geometric-m-blue.png'
import geometricNotM from './images/geometric-not-m-blue.png'
import styles from './styles.module.scss'

import Image from 'next/image'
import clsx from 'clsx'

const copies = [
  {
    title: "Discover Tomorrow's Innovations Today",
    subtitle:
      "Dive into the future of technology and innovation. Don't miss out – secure your spot now!",
  },
  {
    title: 'Join the Forefront of Tech Evolution',
    subtitle:
      'Be part of the conversation shaping our technological future. Register today!',
  },
  {
    title: 'Unlock Insights from Industry Leaders',
    subtitle:
      'Experience groundbreaking discussions and transformative ideas. Reserve your seat!',
  },
  {
    title: 'Experience the Pinnacle of Tech & Innovation',
    subtitle:
      'Stay ahead of the curve and immerse yourself in cutting-edge discussions. Click to join us!',
  },
]

export function RegistrationCallout({ copyIndex }: { copyIndex: number }) {
  return (
    <div className="bg-[#4D2781] relative">
      <Image
        src={geometricM}
        alt=""
        unoptimized
        className="absolute left-0 bottom-0"
      />
      <Image
        src={geometricNotM}
        alt=""
        unoptimized
        className="absolute top-0 right-0"
      />
      <Container className="relative py-14 lg:py-28 grid grid-cols-1 items-center">
        <h2
          className={clsx(
            'text-white font-body lg:sm:text-5xl text-4xl font-bold mb-7',
          )}>
          {copies[copyIndex].title}
        </h2>
        <p className="text-white text-xl">{copies[copyIndex].subtitle}</p>

        <a
          href="https://ti.to/marketx-ventures/technology-innovation-summit"
          className={clsx(
            'bg-[#96FFE5] px-12 py-6 md:px-16 md:py-8 md:text-3xl rounded-xl font-semibold text-2xl mt-10 md:mt-20 max-w-fit text-[#374151] border-2 border-[#374151] hover:opacity-90 transition-opacity',
          )}>
          Register Now
        </a>
      </Container>
    </div>
  )
}
